(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('policyRulesList', ["path", "$q", "rolesManager", "tablePaginationHelper", "policyRulesDao", "policyRuleConfig", "defaultListConverter", "modulesManager", "policyRuleModes", "$timeout", "modals", "columnsHelper", "routeHelper", "http", "policyDao", "feature", "troubleshooting", function (path, $q, rolesManager, tablePaginationHelper, policyRulesDao, policyRuleConfig, defaultListConverter, modulesManager, policyRuleModes, $timeout, modals, columnsHelper, routeHelper, http, policyDao, feature, troubleshooting) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('policy-rules/policy-rules-list').template('policy-rules-list'),
            scope: {
                widgetApi: '=?api',
                saas: '=',
                startCollapsed: '=?'
            },
            link: function ($scope, element, attrs) {
                var autoExpandMax = 5;
                var initialExpandDone = false;
                var showOnlyTypes = 'dlp,malware,clicktime_protection';
                if (feature.lastlineTheme) {
                    showOnlyTypes = 'malware';
                }
                if (feature.showAnomaly) {
                    showOnlyTypes += ',anomaly';
                }
                if (feature.showAccessControlRules) {
                    showOnlyTypes += ',access_control';
                }
                $scope.autoId = 'policy_rule_' + $scope.saas + '_table';
                $scope.saasApp = modulesManager.cloudApp($scope.saas);
                $scope.addHref = routeHelper.getHref('policy-rule-add', {}, { saas: $scope.saasApp.name });
                $scope.statusInfo = '#' + JSON.stringify({
                    display: 'text',
                    'class': 'fa fa-spinner fa-pulse'
                }) + ' Loading';
                $scope.tableOptions = {
                    pagesAround: 2,
                    pageSize: 20,
                    pagination: {
                        page: 1,
                        ordering: {}
                    },
                    disableTop: true,
                    disablePerPageSelector: true,
                    disablePageFirst: true,
                    disablePageJump: true,
                    showWorkingIndicator: true,
                    dropdownHeader: true,
                    headerOptions: { enum: { multiple: true } },
                    bodyScroll: false,
                    bodyScrollAdjustEvent: 'policy-rules-adjust-done',
                    orderDisplayMode: 'highlight-column'
                };
                var modeVariants = angular.copy(policyRuleConfig.saasRuleModes($scope.saas));
                modeVariants.push({
                    id: 'custom',
                    label: 'Custom'
                });
                $scope.options = {
                    options: {
                        checkboxes: false,
                        singleSelection: false,
                        forceServerProcessing: true,
                        defaultOrdering: {
                            columnName: 'created',
                            order: 'desc'
                        }
                    },
                    columns: [
                        {
                            id: 'superId',
                            hidden: true,
                            primary: true,
                            converter: 'superIdConverter',
                            converterArgs: {
                                type: 'rule',
                                idColumn: 'id'
                            },
                            policyColumn: {
                                converterArgs: {
                                    type: 'policy',
                                    idColumn: 'policy_id'
                                }
                            }
                        },
                        {
                            id: 'id',
                            hidden: true,
                            policyColumn: { id: 'policy_id' }
                        },
                        {
                            id: '_removeRule',
                            hidden: !rolesManager.isActionAllowed([
                                'admin',
                                'user'
                            ]) ? true : false,
                            text: false,
                            'class': 'policy-remove-column',
                            dataClass: 'policy-remove-column',
                            converter: 'removeRuleConverter',
                            converterArgs: { type: 'rule' },
                            policyColumn: { converterArgs: { type: 'policy' } }
                        },
                        {
                            id: 'state',
                            text: 'Status',
                            converter: 'ruleState',
                            filter: {
                                name: 'filterEnum_state',
                                type: 'enum'
                            },
                            property: { variants: policyRuleConfig.ruleStates() },
                            policyColumn: { id: 'policy_status' },
                            dataClass: 'policy-state'
                        },
                        {
                            id: 'mode',
                            text: 'Mode',
                            converter: 'ruleModeConverter',
                            filter: {
                                name: 'filterEnum_mode',
                                type: 'enum'
                            },
                            property: { variants: modeVariants },
                            policyColumn: {
                                converter: 'constantConverter',
                                converterArgs: { constant: 'Custom' }
                            }
                        },
                        {
                            id: 'name',
                            text: 'Rule Name',
                            filter: {
                                name: 'filterBy_name',
                                type: 'text'
                            },
                            converter: 'ruleLinkConverter',
                            converterArgs: {
                                type: 'policy-rule-edit',
                                params: { id: 'id' }
                            },
                            policyColumn: {
                                id: 'policy_name',
                                converterArgs: {
                                    type: 'policy-edit',
                                    params: { id: 'policy_id' }
                                }
                            }
                        },
                        {
                            id: '_resolved',
                            hidden: true
                        },
                        {
                            id: 'identity',
                            text: 'Scope',
                            converter: 'ruleIdentityConverter',
                            dataClass: 'rule-scopes',
                            policyColumn: {
                                converter: 'constantConverter',
                                converterArgs: { constant: '' }
                            }
                        },
                        {
                            id: 'actions',
                            text: 'Remediation workflow',
                            converter: 'workflowConverter',
                            policyColumn: {
                                id: 'policy_data.actions',
                                converter: 'policyActionsConverter'
                            }
                        },
                        {
                            id: 'order',
                            text: 'Order',
                            converter: 'orderConverter',
                            'class': 'policy-order-column',
                            dataClass: 'policy-order-column',
                            policyColumn: {
                                converter: 'constantConverter',
                                converterArgs: { constant: '' }
                            },
                            hidden: rolesManager.isActionAllowed([
                                'admin',
                                'user'
                            ]) ? false : true
                        },
                        {
                            id: 'rule',
                            hidden: true
                        },
                        {
                            id: '_sourceIndex',
                            hidden: true
                        },
                        {
                            id: 'system',
                            hidden: true
                        }
                    ]
                };
                function makeSuperId(type, id) {
                    return type + '_' + id;
                }
                var converters = {
                    constantConverter: function (text, columnId, columnsMap, args) {
                        return args.constant;
                    },
                    superIdConverter: function (text, columnId, columnsMap, args) {
                        return makeSuperId(args.type, columnsMap[args.idColumn]);
                    },
                    ruleState: function (text, columnId, columnsMap) {
                        var result = {
                            'display': 'text',
                            'class': { 'rule-state': true },
                            'text': {
                                'running': 'Running',
                                'pause': 'Stopped',
                                'disabled': 'Disabled',
                                'mark_for_deletion': 'Marked for deletion'
                            }[text]
                        };
                        result['class']['state-' + text] = true;
                        if (text === 'running') {
                            result.tooltip = 'Stop';
                            result.clickEvent = { targetState: 'pause' };
                        }
                        if (text === 'pause') {
                            result.tooltip = 'Start';
                            result.clickEvent = { targetState: 'running' };
                        }
                        result.clickEvent = rolesManager.isActionAllowed([
                            'admin',
                            'user'
                        ]) ? result.clickEvent : false;
                        result.tooltip = rolesManager.isActionAllowed([
                            'admin',
                            'user'
                        ]) ? result.tooltip : false;
                        if (result.clickEvent) {
                            result['class']['cursor-pointer'] = true;
                            if (columnId === 'policy_status') {
                                result.tooltip += ' query';
                                result.clickEvent.name = 'policy-state-change';
                                result.clickEvent.policyId = columnsMap.policy_id;
                            } else {
                                result.tooltip += ' rule';
                                result.clickEvent.name = 'rule-state-change';
                                result.clickEvent.ruleId = columnsMap.id;
                            }
                        }
                        return '#' + JSON.stringify(result) + '#' + JSON.stringify({
                            display: 'text',
                            'class': 'fa fa-pulse fa-spinner policy-state-change-indicator'
                        });
                    },
                    ruleIdentityConverter: function (text, columnId, columnsMap) {
                        var limit = 4;
                        function formatText(text) {
                            return '#' + JSON.stringify({
                                display: 'linked-text',
                                'class': 'rule-identity-item',
                                text: text
                            });
                        }
                        var typesConf = {
                            groups: {
                                order: 1,
                                label: 'group'
                            },
                            users: {
                                order: 2,
                                label: 'user'
                            }
                        };
                        var list;
                        var counts;
                        if (_(text.groups).isEmpty() && _(text.users).isEmpty()) {
                            var scopesText = formatText(policyRuleConfig.formatIdentity({
                                gui_label: 'All Users and groups',
                                type: 'users'
                            }));
                            if (text.exclude && !_(text.exclude).isEmpty()) {
                                list = policyRuleConfig.identitiesToList(columnsMap);
                                counts = '';
                                if (list && list.excludes && list.excludes.length > limit) {
                                    counts = formatText('and ' + _(list.excludes).chain().rest(limit).reduce(function (memo, item) {
                                        memo[item.type] = (memo[item.type] || 0) + 1;
                                        return memo;
                                    }, {}).map(function (item, type) {
                                        return {
                                            type: type,
                                            count: item
                                        };
                                    }).sortBy(function (item) {
                                        return (typesConf[item.type] || { order: 9999 }).order;
                                    }).map(function (item, idx) {
                                        return item.count + (idx === 0 ? ' more ' : ' ') + (typesConf[item.type] && typesConf[item.type].label + (item.count > 1 ? 's' : '') || item.type);
                                    }).value().join(', '));
                                    list.excludes = _(list.excludes).first(limit);
                                }
                                return scopesText + 'Excludes: ' + _(list.excludes).map(function (item) {
                                    return formatText(policyRuleConfig.formatIdentity(item));
                                }).join('') + counts;
                            }
                            return scopesText;
                        } else {
                            list = policyRuleConfig.identitiesToList(columnsMap);
                            counts = '';
                            if (list && list.scopes && list.scopes.length > limit) {
                                counts = formatText('and ' + _(list.scopes).chain().rest(limit).reduce(function (memo, item) {
                                    memo[item.type] = (memo[item.type] || 0) + 1;
                                    return memo;
                                }, {}).map(function (item, type) {
                                    return {
                                        type: type,
                                        count: item
                                    };
                                }).sortBy(function (item) {
                                    return (typesConf[item.type] || { order: 9999 }).order;
                                }).map(function (item, idx) {
                                    return item.count + (idx === 0 ? ' more ' : ' ') + (typesConf[item.type] && typesConf[item.type].label + (item.count > 1 ? 's' : '') || item.type);
                                }).value().join(', '));
                                list.scopes = _(list.scopes).first(limit);
                            }
                            return _(list.scopes).map(function (item) {
                                return formatText(policyRuleConfig.formatIdentity(item));
                            }).join('') + counts;
                        }
                    },
                    workflowConverter: function (text, columnId, columnsMap) {
                        var result = '';
                        if (columnsMap._resolved.workflows) {
                            var workflows = policyRuleConfig.workflows();
                            _(workflows).each(function (workflow) {
                                if (columnsMap._resolved.workflows[workflow.id]) {
                                    result += '#' + JSON.stringify({
                                        display: 'text',
                                        'class': 'workflow-item',
                                        tooltip: workflow.listLabel + ': ' + columnsMap._resolved.workflows[workflow.id],
                                        text: workflow.listLabel + ': ' + columnsMap._resolved.workflows[workflow.id]
                                    });
                                }
                            });
                        }
                        if (columnsMap.actions) {
                            _(columnsMap.actions).each(function (actions) {
                                _(actions).each(function (action) {
                                    var actionId = action.id;
                                    if (!actionId) {
                                        return;
                                    }
                                    if (!columnsMap._resolved.actions || !columnsMap._resolved.actions[actionId] || !columnsMap._resolved.actions[actionId].label) {
                                        return;
                                    }
                                    result += '#' + JSON.stringify({
                                        display: 'text',
                                        'class': 'display-block',
                                        text: columnsMap._resolved.actions[actionId].label
                                    });
                                });
                            });
                        }
                        return result;
                    },
                    ruleModeConverter: function (text) {
                        return policyRuleModes.labelShort(text);
                    },
                    removeRuleConverter: function (text, columnId, columnsMap, args) {
                        return '#' + JSON.stringify({
                            display: 'text',
                            'class': 'fa fa-times policy-remove-indicator',
                            clickEvent: {
                                'name': 'remove-' + args.type,
                                itemId: args.type === 'policy' ? columnsMap.policy_id : columnsMap.id,
                                itemName: args.type === 'policy' ? columnsMap.policy_name : columnsMap.name
                            },
                            tooltip: 'Remove ' + (args.type === 'policy' ? 'Query' : 'Rule')
                        });
                    },
                    orderConverter: function (text, columnId, columnsMap) {
                        var result = '';
                        if (!columnsMap.system || columnsMap.system && troubleshooting.entityDebugEnabled()) {
                            if (columnsMap._sourceIndex > 0 && sourceData[columnsMap._sourceIndex - 1].mode === columnsMap.mode) {
                                result += '#' + JSON.stringify({
                                    display: 'text',
                                    'class': 'fa fa-arrow-up policy-order policy-order-up',
                                    clickEvent: {
                                        'name': 'policy-change-order',
                                        ruleId: columnsMap.id,
                                        exchangeWithId: sourceData[columnsMap._sourceIndex - 1].id
                                    },
                                    tooltip: 'Move Up'
                                });
                            }
                            if (columnsMap._sourceIndex < sourceData.length - 1 && sourceData[columnsMap._sourceIndex + 1].mode === columnsMap.mode) {
                                result += '#' + JSON.stringify({
                                    display: 'text',
                                    'class': 'fa fa-arrow-down policy-order policy-order-down',
                                    clickEvent: {
                                        'name': 'policy-change-order',
                                        ruleId: columnsMap.id,
                                        exchangeWithId: sourceData[columnsMap._sourceIndex + 1].id
                                    },
                                    tooltip: 'Move Down'
                                });
                            }
                        } else {
                            result = '#' + JSON.stringify({ display: 'text' });
                        }
                        return result;
                    },
                    policyActionsConverter: function (text, columnId, columnsMap) {
                        return _(text).map(function (action) {
                            return '#' + JSON.stringify({
                                display: 'text',
                                'class': 'display-block',
                                text: action.label
                            });
                        }).join('');
                    },
                    ruleLinkConverter: function (text, columnId, columnsMap, args, converters) {
                        if (!args || !text) {
                            return text;
                        }
                        var linkParams = converters._makeLinkParams(columnsMap, args);
                        if (!linkParams) {
                            return text;
                        }
                        linkParams.text = text;
                        return '#' + JSON.stringify(linkParams);
                    }
                };
                var sourceData = [];
                var policyListColumns = _($scope.options.columns).map(function (column) {
                    return $.extend({}, column, column.policyColumn);
                });
                $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                    var filterParams = _(args.columnsFilters).chain().map(function (value, name) {
                        var first = _(value).first();
                        if (first.type == 'text' && first.operator == 'contains') {
                            return [
                                name,
                                first.data
                            ];
                        }
                        if (first.type == 'enum' && first.operator == 'is') {
                            return [
                                name,
                                _(value).map(function (v) {
                                    return v.data;
                                }).join(',')
                            ];
                        }
                        if (first.type === 'boolean' && first.operator === 'is') {
                            return [
                                name,
                                first.data
                            ];
                        }
                        return null;
                    }).compact().object().value();
                    if (!filterParams.filterEnum_state) {
                        filterParams.filterEnum_state = 'running,pause';
                    }
                    filterParams.filterEnum_saas = $scope.saas;
                    if (showOnlyTypes) {
                        filterParams.filterEnum_type = showOnlyTypes;
                    }
                    var ruleCountsParams = angular.copy(filterParams);
                    ruleCountsParams = _(ruleCountsParams).omit('filterEnum_saas');
                    ruleCountsParams.groupBy = 'saas,state';
                    var ruleCounts;
                    if (ruleCountsParams.filterEnum_mode && !_(ruleCountsParams.filterEnum_mode.split(',')).intersection(_(policyRuleConfig.saasRuleModes($scope.saas)).pluck('id')).length) {
                        ruleCounts = $q.when({
                            total: 0,
                            running: 0
                        });
                    } else {
                        ruleCounts = policyRulesDao.list().params(ruleCountsParams).converter(function (response) {
                            var counts = {
                                total: 0,
                                running: 0
                            };
                            if (response.data && response.data.rows) {
                                _(response.data.rows).each(function (row) {
                                    if (row.saas !== $scope.saas) {
                                        return;
                                    }
                                    if (row.state === 'running') {
                                        counts.running += row.count;
                                    }
                                    counts.total += row.count;
                                });
                            }
                            return $q.when(counts);
                        });
                    }
                    var filterTransforms = {
                        'filterBy_name': 'filterBy_policy_name',
                        'filterEnum_state': 'fitlerEnum_policy_status'
                    };
                    var policyFilters = {
                        hide_hidden: true,
                        hide_system: true,
                        hide_temporary: true,
                        only_with_actions: true
                    };
                    var policyFilterParams = {};
                    _(ruleCountsParams).each(function (value, key) {
                        if (filterTransforms[key]) {
                            policyFilterParams[filterTransforms[key]] = value;
                        }
                    });
                    $.extend(policyFilterParams, policyFilters);
                    var policyCounts;
                    if (filterParams.filterEnum_mode && !_(filterParams.filterEnum_mode.split(',')).includes('custom')) {
                        policyCounts = $q.when({
                            total: 0,
                            running: 0
                        });
                    } else {
                        policyCounts = policyDao.policySaasStatusCounts().params(policyFilterParams).converter(function (response) {
                            var counts = {
                                total: 0,
                                running: 0
                            };
                            if (response.data && response.data.rows) {
                                _(response.data.rows).each(function (row) {
                                    if (row.saas !== $scope.saas) {
                                        return;
                                    }
                                    if (row.policy_status === 'running') {
                                        counts.running += row.count;
                                    }
                                    counts.total += row.count;
                                });
                            }
                            return $q.when(counts);
                        });
                    }
                    function rulesRows(args) {
                        if (args.limit < 1) {
                            return $q.when({ data: { data: [] } });
                        }
                        var queryOffset, queryLimit;
                        if (args.offset > 0) {
                            queryOffset = args.offset - 1;
                            queryLimit = args.limit + 2;
                        } else {
                            queryOffset = args.offset;
                            queryLimit = args.limit + 1;
                        }
                        return policyRulesDao.list().params(filterParams).pagination(queryOffset, queryLimit).order('mode,order,id', 'asc,asc,asc').converter(function (input) {
                            // show dlp2 policy rules for only debug mode
                            $scope.disabledCounts = {
                                total: 0,
                                running: 0
                            };
                            input.data.rows = _(input.data.rows).reject(function (row) {
                                if (!troubleshooting.entityDebugEnabled() && row.rule && row.rule.active_sectools) {
                                    var dlpTools = [];
                                    if (row.rule.active_sectools.any && row.rule.active_sectools.any.length) {
                                        dlpTools = row.rule.active_sectools.any;
                                    } else if (row.rule.active_sectools.all_tools && row.rule.active_sectools.dlp_tools && row.rule.active_sectools.dlp_tools.length) {
                                        dlpTools = row.rule.active_sectools.dlp_tools;
                                    }
                                    if (dlpTools.length && _(dlpTools).findIndex(function (sectool) {
                                            return sectool == 'dlp_checkpoint2';
                                        }) !== -1) {
                                        $scope.disabledCounts.total++;
                                        if (row.state === 'running') {
                                            $scope.disabledCounts.running++;
                                        }
                                        return true;
                                    }
                                }
                                return false;
                            });
                            sourceData = input.data.rows;
                            _(sourceData).each(function (row, idx) {
                                row._sourceIndex = idx;
                            });
                            var rows = input.data.rows;
                            if (args.offset > 0 && rows.length) {
                                rows = rows.slice(1);
                            }
                            if (rows.length > args.limit) {
                                rows = rows.slice(0, args.limit);
                            }
                            input.data.rows = rows;
                            return $q.when(input);
                        }, _.identity).converter(defaultListConverter, {
                            columns: $scope.options.columns,
                            converters: converters
                        }).run();
                    }
                    function policyRows(args) {
                        if (args.limit < 1) {
                            return $q.when({ data: { data: [] } });
                        }
                        return policyDao.policyCatalog($scope.saas).params(policyFilterParams).pagination(args.offset, args.limit).order('policy_id', 'asc').converter(defaultListConverter, {
                            columns: policyListColumns,
                            converters: converters
                        }).run();
                    }
                    return http.local().preFetch(ruleCounts, 'ruleCounts').preFetch(policyCounts, 'policyCounts').converter(function (input, preFetches) {
                        var totalCounts = {
                            total: preFetches.ruleCounts.total + preFetches.policyCounts.total,
                            running: preFetches.ruleCounts.running + preFetches.policyCounts.running
                        };
                        var rulesPage = {
                            offset: 0,
                            limit: 0
                        };
                        var policyPage = {
                            offset: 0,
                            limit: 0
                        };
                        if (args.offset < preFetches.ruleCounts.total) {
                            rulesPage.offset = args.offset;
                            rulesPage.limit = args.limit;
                        }
                        if (preFetches.policyCounts.total > 0) {
                            policyPage.offset = Math.max(0, args.offset - preFetches.ruleCounts.total);
                            policyPage.limit = Math.max(0, args.limit - Math.max(0, preFetches.ruleCounts.total - args.offset));
                        }
                        return $q.all([
                            rulesRows(rulesPage),
                            policyRows(policyPage)
                        ]).then(function (responses) {
                            var data = _(responses).chain().map(function (r) {
                                return r.data.data;
                            }).flatten(true).value();
                            // minus disabled rules count
                            $scope.runningCount = totalCounts.running;
                            if ($scope.disabledCounts) {
                                totalCounts.total -= $scope.disabledCounts.total;
                                $scope.runningCount -= $scope.disabledCounts.running;
                            }
                            return {
                                data: {
                                    data: data,
                                    pagination: {
                                        total: totalCounts.total,
                                        current: args.offset / args.limit + 1
                                    }
                                }
                            };
                        });
                    }, _.identity);
                }, function (tableModel) {
                    var total = $scope.tableHelper.getTotal();
                    $scope.tableModel = tableModel;
                    updateRowClasses();
                    $scope.statusInfo = '#' + JSON.stringify({
                        display: 'text',
                        'class': 'total-word',
                        text: 'Total'
                    }) + ' ' + total + ' Rules';
                    if (!_($scope.runningCount).isUndefined()) {
                        $scope.statusInfo += ' / ' + $scope.runningCount + ' Running';
                    }
                    if (!initialExpandDone) {
                        initialExpandDone = true;
                        if (total <= autoExpandMax && !$scope.expanded && !$scope.startCollapsed) {
                            $timeout(function () {
                                $scope.toggleExpanded();
                            });
                        }
                    }
                });
                var expandableEl = element.find('.expandable');
                var heightFixerTimer = null;
                $scope.expanded = true;
                $scope.toggleExpanded = function () {
                    if (heightFixerTimer) {
                        $timeout.cancel(heightFixerTimer);
                    }
                    if ($scope.expanded) {
                        expandableEl[0].style.height = expandableEl[0].scrollHeight + 'px';
                        $timeout(function () {
                            expandableEl[0].style.height = '0';
                            $scope.expanded = false;
                            expandableEl.addClass('collapsed');
                            expandableEl[0].style.overflow = 'hidden';
                        });
                    } else {
                        expandableEl.removeClass('collapsed');
                        expandableEl[0].style.height = expandableEl[0].scrollHeight + 'px';
                        $scope.expanded = true;
                        heightFixerTimer = $timeout(function () {
                            heightFixerTimer = null;
                            expandableEl[0].style.height = 'auto';
                            expandableEl[0].style.overflow = 'visible';
                        }, 450);
                    }
                };
                var ruleUpdating = {};
                var ruleStateChanging = {};
                $scope.toggleExpanded();
                function updateRowClasses() {
                    if (!$scope.tableModel || !$scope.tableModel.data) {
                        return;
                    }
                    var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
                    _($scope.tableModel.data).each(function (row, idx) {
                        $scope.tableModel.rowClasses[idx] = $scope.tableModel.rowClasses[idx] || {};
                        if (ruleUpdating[row[primaryColumn].text]) {
                            $scope.tableModel.rowClasses[idx].processing = true;
                        } else {
                            delete $scope.tableModel.rowClasses[idx].processing;
                        }
                        if (ruleStateChanging[row[primaryColumn].text]) {
                            $scope.tableModel.rowClasses[idx]['state-changing'] = true;
                        } else {
                            delete $scope.tableModel.rowClasses[idx]['state-changing'];
                        }
                    });
                }
                $scope.$on('remove-rule', function (event, data) {
                    var superId = makeSuperId('rule', data.itemId);
                    modals.confirm({
                        message: 'Are you sure you want to delete rule "' + data.itemName + '"?',
                        title: 'Delete Rule'
                    }).then(function () {
                        ruleUpdating[superId] = true;
                        updateRowClasses();
                        return policyRulesDao.delete(data.itemId).then(function () {
                            var primaryColumnIdx = columnsHelper.getPrimaryIdx($scope.options.columns);
                            var rowIdx = _($scope.tableModel.data).findIndex(function (row) {
                                return row[primaryColumnIdx].text === superId;
                            });
                            if (rowIdx !== -1) {
                                $scope.tableModel.data.splice(rowIdx, 1);
                            }
                        }).finally(function () {
                            ruleUpdating[superId] = false;
                            updateRowClasses();
                        });
                    });
                });
                $scope.$on('remove-policy', function (event, data) {
                    var superId = makeSuperId('policy', data.itemId);
                    modals.confirm({
                        message: 'Are you sure you want to delete query "' + data.itemName + '"?',
                        title: 'Delete Query'
                    }).then(function () {
                        ruleUpdating[superId] = true;
                        updateRowClasses();
                        return policyDao.changeBatchStatus([data.itemId], 'mark_for_deletion').then(function () {
                            var primaryColumnIdx = columnsHelper.getPrimaryIdx($scope.options.columns);
                            var rowIdx = _($scope.tableModel.data).findIndex(function (row) {
                                return row[primaryColumnIdx].text === superId;
                            });
                            if (rowIdx !== -1) {
                                $scope.tableModel.data.splice(rowIdx, 1);
                            }
                        }).finally(function () {
                            ruleUpdating[superId] = false;
                            updateRowClasses();
                        });
                    });
                });
                $scope.$on('policy-change-order', function (event, data) {
                    ruleUpdating[makeSuperId('rule', data.ruleId)] = true;
                    ruleUpdating[makeSuperId('rule', data.exchangeWithId)] = true;
                    updateRowClasses();
                    policyRulesDao.reorder(data.ruleId, data.exchangeWithId).then(function () {
                        return $scope.tableHelper.reload();
                    }).finally(function () {
                        ruleUpdating[makeSuperId('rule', data.ruleId)] = false;
                        ruleUpdating[makeSuperId('rule', data.exchangeWithId)] = false;
                        updateRowClasses();
                    });
                });
                function stateChangingIndicator(superId, state) {
                    ruleUpdating[superId] = state;
                    ruleStateChanging[superId] = state;
                    updateRowClasses();
                }
                $scope.$on('rule-state-change', function (event, data) {
                    var originalRule = _(sourceData).find(function (rule) {
                        return rule.id === data.ruleId;
                    });
                    if (!originalRule) {
                        return;
                    }
                    var superId = makeSuperId('rule', data.ruleId);
                    stateChangingIndicator(superId, true);
                    var newRule = $.extend(true, {}, _(originalRule).omit('_resolved', '_sourceIndex', 'created', 'updated'), { state: data.targetState });
                    policyRulesDao.update(data.ruleId, newRule).then(function (response) {
                        return $scope.tableHelper.reload();
                    }).finally(function () {
                        stateChangingIndicator(superId, false);
                    });
                });
                $scope.$on('policy-state-change', function (event, data) {
                    var superId = makeSuperId('policy', data.policyId);
                    stateChangingIndicator(superId, true);
                    policyDao.changeBatchStatus([data.policyId], data.targetState).then(function () {
                        return $scope.tableHelper.reload();
                    }).finally(function () {
                        stateChangingIndicator(superId, false);
                    });
                });
                $scope.widgetApi = $scope.widgetApi || {};
                $scope.widgetApi.reload = function () {
                    if (!$scope.tableHelper) {
                        return $q.when();
                    }
                    $scope.tableHelper.clearSelection();
                    return $scope.tableHelper.reload();
                };
            }
        };
    }]);
}());